import ProfileCardConnected from "PFApp/components/profile_card_connected";
import { useSearchDispatch, useSearchStoreContext } from "PFApp/search/search_context";
import useIsChatEnabled from "PFApp/use_is_chat_enabled";
import { Button } from "PFComponents/button";
import { Stack } from "PFComponents/containers/flex/stack";
import { LoadingDots } from "PFComponents/loading_dots";
import { SEARCH_ACTIONS } from "PFReducers/search_reducer/search_reducer";
import { useTranslation } from "react-i18next";

import { calcFiltersLength } from "../helpers/calc_filters_length";
import MoreButton from "../parts/more_button";
import EmptyProfiles from "./empty_profiles";
import css from "./results.module.scss";

const Info = () => {
  const dispatch = useSearchDispatch();
  const {
    search: { profilesPending, profilesRequestFilters, profilesMeta, term }
  } = useSearchStoreContext();
  const { t } = useTranslation("search");

  if (profilesMeta.total > 0) {
    const count = calcFiltersLength(profilesRequestFilters);

    return (
      <div className={css.profilesMatchInfo}>
        {profilesPending ? "..." : t("results.countProfilesMatched", { count: profilesMeta.total, term })}
        {count > 0 && (
          <Button
            kind="text"
            onClick={() => dispatch({ type: SEARCH_ACTIONS.SEARCH_CLEAR_PROFILES_FILTERS })}
          >
            {t("results.clearFilters", { count })}
          </Button>
        )}
      </div>
    );
  }
  return false;
};

const ResultsProfiles = () => {
  const dispatch = useSearchDispatch();
  const {
    search: { profiles, profilesMeta, profilesPending, profilesPage }
  } = useSearchStoreContext();
  const isChatEnabled = useIsChatEnabled();

  return (
    <>
      <Info />
      {profiles.length === 0 &&
        (!profilesMeta.searchId ? <LoadingDots circlesEnabled pageViewEnabled /> : <EmptyProfiles />)}
      <Stack style={{ opacity: profilesPending ? 0.5 : 1 }}>
        {profiles.map((profile) => (
          <ProfileCardConnected key={profile.id} profileResponse={profile} withChat={isChatEnabled} />
        ))}
      </Stack>
      <MoreButton
        isLoading={profilesPending}
        renderedItemsCount={profiles.length}
        total={profilesMeta.total || 0}
        handleClick={() => dispatch({ type: SEARCH_ACTIONS.SEARCH_MORE_PROFILES })}
        perPage={10}
        page={profilesPage}
      />
    </>
  );
};
export default ResultsProfiles;
